import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { Link as _Link, matchPath } from 'react-router-dom';
import { usePathsContext } from '../../hooks';

function _trimSearch(href) {
  return href.slice(0, href.indexOf('?'));
}

export var Link = function Link(_ref) {
  var href = _ref.href,
      _ref$noWarn = _ref.noWarn,
      noWarn = _ref$noWarn === void 0 ? false : _ref$noWarn,
      rest = _objectWithoutProperties(_ref, ["href", "noWarn"]);

  var paths = usePathsContext();

  if (!paths.some(function (path) {
    return matchPath(path, _trimSearch(href)) != null;
  }) && !noWarn) {
    console.warn("Link href \"".concat(href, "\" does not match any known paths."));
  }

  return /*#__PURE__*/React.createElement(_Link, _extends({}, rest, {
    to: href
  }));
};